import { render, staticRenderFns } from "./classifications.vue?vue&type=template&id=6cdcabe8&"
import script from "./classifications.vue?vue&type=script&lang=js&"
export * from "./classifications.vue?vue&type=script&lang=js&"
import style0 from "./classifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports